var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.5,45.5a16.5,16.5,0,0,1-33,0C24.5,36.39,41,13,41,13S57.5,36.39,57.5,45.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "108.5 58 91.5 58 97.5 35 71.5 67 88.5 67 82.5 90 108.5 58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 96,
    x2: 57.5,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 80,
    x2: 66.5,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.5,
    y1: 113,
    x2: 108.5,
    y2: 113
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbms);
export default __webpack_public_path__ + "static/media/ibms.73fa61a10840210de69aaad7344acaf5.svg";
export { ForwardRef as ReactComponent };